import { Outlet } from 'react-router-dom'

import { Avatar } from '@percent/lemonade'
import styles from './Layout.module.scss'
import { LayoutProps } from './Layout.types'
import { Footer } from './Footer/Footer'

export const Layout = ({ children, logo, programName, termsLabel, privacyLabel }: LayoutProps) => (
  <div className={styles.outerContainer}>
    <div className={styles.brandedBackground} />
    <Outlet />
    <div className={styles.container}>
      {logo && (
        <div className={styles.logoWrapper}>
          <Avatar image={logo} size="xlarge" alt={programName ?? 'Unnamed program logo'} />
        </div>
      )}
      {children}
      <Footer termsLabel={termsLabel} privacyLabel={privacyLabel} />
    </div>
  </div>
)
